/* @flow */
import * as React from 'react';

import { handleSendCodeError } from 'settings/lib/emailDeviceVerificationHelpers';
import CurrentUser from 'auth/CurrentUser';
import DeviceActions from 'actions/DeviceActions';
import Link from 'components/Link';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';

/* Component to resend a confirmation email:
 *
 * if (user.getUnconfirmedEmail()) {
 *  var resent = <ResendConfirmationEmail>Click me!</ResendConfirmationEmail>;
 * }
 *
 */

type Props = {
  /* silences all the toasts, default false */
  silent?: boolean,
  /* called if API returned 2xx */
  onSuccess?: Function,
  /* called if API did not return 2xx */
  onError?: Function,
  email: {
    endpoint: string,
    id: number,
    type: 'email',
  },
  children?: React$Node,
  onShowDialog?: () => void,
};

class ResendConfirmationEmail extends React.Component<Props> {
  static defaultProps = {
    silent: false,
  };

  resendConfirmation = () => {
    const { email, silent, onError, onSuccess } = this.props;
    const success = () => {
      const emailAddress = (email && email.endpoint) || CurrentUser.getUser().getUnconfirmedEmail();

      if (!silent) {
        ToastActions.showSuccessToast(`Sent confirmation link to ${emailAddress}`);
      }
      if (onSuccess) {
        onSuccess();
      }
    };

    const onFailure = () => {
      if (!silent) {
        ToastActions.showDefaultErrorToast();
      }
      if (onError) {
        onError();
      }
    };

    if (email && email.endpoint) {
      DeviceActions.outboundVerify(email.endpoint)
        .then(() => {
          if (this.props.onShowDialog) {
            this.props.onShowDialog();
          }
          ToastActions.showSuccessToast(`Sent email to ${email.endpoint}`);
        }, handleSendCodeError)
        .catch((err: any) => {
          console.debug(err);
          console.error(err.toString());
          ToastActions.showDefaultErrorToast();
        });
    } else {
      UserActions.requestConfirmation().then(success, onFailure);
    }
  };

  render() {
    return (
      <Link
        data-test="resend-confirmation-email-link"
        onClick={this.resendConfirmation}
        {...this.props}>
        {this.props.children}
      </Link>
    );
  }
}

export default ResendConfirmationEmail;
